module.exports = __webpack_public_path__ + "static/img/zhelian-logo.7604c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhelian-logo.png
// module id = auNd
// module chunks = 87